module.exports = __webpack_public_path__ + "img/CB2-L1-B.771fa6e5.gif";